require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-money-back-guarantees-placement-stats-starting-salaries-oh-my.json") })
        }
      }, "path---blog-money-back-guarantees-placement-stats-starting-salaries-oh-my");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-money-back-guarantees-placement-stats-starting-salaries-oh-my!./.cache/json/blog-money-back-guarantees-placement-stats-starting-salaries-oh-my.json
// module id = 984
// module chunks = 231608221292675